export default {
  container: {
    borderRadius: "12px",
    minHeight: "570px",
    background: "#FFFFFF",
    width: "100%",
  },
  inforTitle: {
    color: "#8C8C8C",
    fontSize: "20px",
  },
  flexContainer: {
    display: "flex",
  },
  keyStyle: {
    color: "#5E5E5E",
    fontSize: "14px",
  },
  valueStyle: {
    color: "#183053",
    fontSize: "16px",
  },
  buttonStyles: {
    marginTop: "32px",
    width: "150px",
  },
  titleStyles: {
    color: "#5E5E5E",
    fontSize: "14px",
    marginTop: "8px",
    marginBottom: "8px",
    fontWeight: "600",
    width: "150px",
    marginRight: "47px",
  },
  rowStyles: {
    color: "#183053",
    textTransform: "capitalize",
    fontWeight: "500",
    fontSize: "14px",
    padding: "12px",
    paddingLeft: 0,
    borderBottom: "none",
  },
  mediumItem: {
    width: "12%",
  },
  largeItem: {
    width: "18%",
  },
  smallItem: {
    width: "10%",
  },
  avatarContainer: {
    display: "flex",
    gap: 10,
  },
  avatar: {
    padding: 5,
    fontSize: 12,
  },
  memberIdstyles: {
    color: "#183053",
    fontWeight: "500",
  },
  redText: {
    color: "red",
  },
};
